/* eslint-disable import/prefer-default-export */

import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var item = /*#__PURE__*/css("display:flex;width:100%;gap:4px;margin-top:4px;color:", colors.neutral.heavy.default, ";");
var _ref = {
  name: "15fzge",
  styles: "margin-left:4px;"
};
export var itemLabel = hasIcon => /*#__PURE__*/css(designTokenFonts.body, " white-space:nowrap;", hasIcon && _ref);
export var itemValue = /*#__PURE__*/css("flex-grow:2;", designTokenFonts.bodyBold, ";");